<template>
    <div class='sectionBox'>
        <span v-if='valueStr === "0"'>关</span>
        <span v-else-if='valueStr === "1"'>开</span>
        <span v-else> {{valueStr}}</span>
    </div>
</template>

<script>
export default {
    props: {
        valueStr: String
    },

    computed: {
        dictionary() {
            return this.$store.state.dictionary
        }
    },
}
</script>

<style lang='scss' scoped>
    .sectionBox {
        max-height: 60px;
        overflow: hidden;
        line-height: 20px;
    }
</style>
